export default __webpack_public_path__ + "static/media/ankle1.2c363931.png";